import { useLocation, useNavigate } from 'react-router-dom';
import { Home, Search, Heart, User } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const BottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, login } = useAuth();

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  const handleProfileClick = () => {
    if (user) {
      if (user.is_admin) {
        navigate('/admin');
      } else {
        // For regular users, just show they're logged in
        navigate('/');
      }
    } else {
      login();
    }
  };

  const handleSearchClick = () => {
    // Scroll to search on home page or navigate to home with search focus
    if (location.pathname === '/') {
      const searchInput = document.querySelector('[data-testid="search-input"]');
      if (searchInput) {
        searchInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
        searchInput.focus();
      }
    } else {
      navigate('/', { state: { focusSearch: true } });
    }
  };

  const handleFavoritesClick = () => {
    // Navigate to top rated section
    if (location.pathname === '/') {
      const topRated = document.getElementById('top-rated');
      if (topRated) {
        topRated.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate('/#top-rated');
    }
  };

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-slate-200 safe-area-bottom">
      <div className="flex items-center justify-around h-16 px-2">
        {/* Home */}
        <button
          onClick={() => navigate('/')}
          className={`flex flex-col items-center justify-center flex-1 py-2 transition-colors ${
            isActive('/') && location.pathname === '/' ? 'text-[#FF5A00]' : 'text-slate-400'
          }`}
          data-testid="bottom-nav-home"
        >
          <Home className={`h-6 w-6 ${isActive('/') && location.pathname === '/' ? 'fill-[#FF5A00]/20' : ''}`} />
          <span className="text-xs mt-1 font-medium">Início</span>
        </button>

        {/* Search */}
        <button
          onClick={handleSearchClick}
          className="flex flex-col items-center justify-center flex-1 py-2 text-slate-400 hover:text-[#FF5A00] transition-colors"
          data-testid="bottom-nav-search"
        >
          <Search className="h-6 w-6" />
          <span className="text-xs mt-1 font-medium">Buscar</span>
        </button>

        {/* Favorites / Top Rated */}
        <button
          onClick={handleFavoritesClick}
          className="flex flex-col items-center justify-center flex-1 py-2 text-slate-400 hover:text-[#FF5A00] transition-colors"
          data-testid="bottom-nav-favorites"
        >
          <Heart className="h-6 w-6" />
          <span className="text-xs mt-1 font-medium">Top</span>
        </button>

        {/* Profile */}
        <button
          onClick={handleProfileClick}
          className={`flex flex-col items-center justify-center flex-1 py-2 transition-colors ${
            user ? 'text-[#FF5A00]' : 'text-slate-400'
          }`}
          data-testid="bottom-nav-profile"
        >
          {user ? (
            <div className="w-6 h-6 rounded-full overflow-hidden border-2 border-[#FF5A00]">
              <img 
                src={user.picture || '/favicon.svg'} 
                alt={user.name}
                className="w-full h-full object-cover"
              />
            </div>
          ) : (
            <User className="h-6 w-6" />
          )}
          <span className="text-xs mt-1 font-medium">{user ? 'Perfil' : 'Entrar'}</span>
        </button>
      </div>
    </nav>
  );
};

export default BottomNav;
